export const numberWithCommas_display = (x) => {
    if((x!== null) && !isNaN(x)){
      if (x === '0' || x === 0) {return '0.00'}
      // else{
        var y = roundup(x).toFixed(2);
        return y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // }
    }
    // return null;
    else{
      // console.log('not a number')
      return x
    }
    // return 'NaN';
  
}


export const roundup = (x) => {
  return (Math.round(x*100) / 100);
}

export const changeFloat = (x) => {
  if((x!== null) && !isNaN(x) && x!=='' && x!== undefined){
    if (x === '0' || x === 0) {return 0}
    return parseFloat(x);
  }
  return 0;
}